/* eslint css-modules/no-unused-class: [2, { markAsUsed: ['default', 'clear'] }] */
import { ReactNode } from 'react';
import classNames from 'classnames';

import classes from './FilterButton.module.scss';

type Props = {
  variant?: 'default' | 'clear';
  children: ReactNode;
};

const FilterButton = ({ variant = 'default', children }: Props): JSX.Element => (
  <div className={classNames(classes.wrapper, classes[variant])}>{children}</div>
);

export default FilterButton;
